import DataloggerProvider from '../providers/DataloggerProvider'

class DataloggerService {
  GetInServiceDataloggersWithoutSignOfLife (callback) {
    return DataloggerProvider.GetInServiceDataloggersWithoutSignOfLife().then((result) => {
      if (result.data) {
        callback(result.data.length)
      }
    }).catch(e => {
      console.log('Error in GetInServiceDataloggersWithoutSignOfLife: ' + e)
    })
  }
}
export const DataloggerServiceSingle = new DataloggerService()



// WEBPACK FOOTER //
// ./src/services/DataloggerService.js